/* -*- Mode: javascript; indent-tabs-mode: nil; c-basic-offset: 2 -*- */

/**
 * url - A simple filter to ensure a string to be a URL.
 * @memberof SOGo.Common
 */
(function () {
  'use strict';

  /**
   * @ngInject
   */
  function url() {
    return function(url) {
      return url.indexOf('://') < 0 ? 'http://' + url : url;
    };
  }

  angular.module('SOGo.Common')
    .filter('url', url);
})();
